import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            d="M12.928 4c.988.026 1.927.658 2.566 1.754a3.606 3.606 0 0 1-.322 4.143c-.416.508-.894.962-1.346 1.44-.272.288-.529.59-.822.854-.697.624-1.522.876-2.447.739a2.687 2.687 0 0 1-1.44-.69c-.29-.267-.561-.559-.818-.858-.33-.384-.2-.896.258-1.1a.664.664 0 0 1 .748.161c.198.21.399.418.597.627.645.684 1.608.647 2.246.018.68-.672 1.354-1.359 1.958-2.097.562-.687.63-1.505.296-2.333-.543-1.348-2.22-1.685-3.264-.662-.206.201-.388.427-.6.623-.279.256-.694.217-.942-.07a.66.66 0 0 1 .003-.904c.35-.388.672-.805 1.124-1.09.591-.374 1.198-.556 2.205-.555Z"
        />
        <path
            fill="currentColor"
            d="M7.409 15.999c-1.654-.037-3.065-1.284-3.349-2.93a3.7 3.7 0 0 1 .398-2.465c.132-.242.304-.469.492-.67.63-.684 1.253-1.376 1.921-2.02.888-.856 1.939-1.092 3.118-.675.386.136.716.358 1.004.64.24.236.47.484.693.735a.678.678 0 0 1-.96.955c-.205-.188-.378-.409-.573-.605-.416-.418-.922-.604-1.502-.49a1.758 1.758 0 0 0-.99.578c-.54.601-1.098 1.183-1.654 1.769-.845.887-.83 2.496.151 3.298.734.6 1.927.693 2.717-.19.164-.183.343-.353.521-.523.285-.27.645-.277.94-.027.28.24.35.62.113.918-.724.915-1.59 1.613-2.817 1.7-.074.006-.149 0-.224 0V16Z"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
